<form [formGroup]="form" novalidate *ngIf="form">
  <div class="mt-3" *ngIf="(showTwoPlayers$ | async) || (showFourPlayers$ | async)">
    <div class="text-uppercase font-weight-bold" translate>CourtBookingSave.AddSecondPlayerLabel</div>
    <app-court-booking-save-player-add formControlName="secondPlayer" [playerRules]="secondPlayerRules$ | async"
      [categoryName]="categoryName$ | async" [players]="(players$ | async).items">
    </app-court-booking-save-player-add>
  </div>
  <div class="mt-3" *ngIf="(showFourPlayers$ | async)">
    <div class="text-uppercase font-weight-bold" translate>CourtBookingSave.AddThirdPlayerLabel</div>
    <app-court-booking-save-player-add formControlName="thirdPlayer" [playerRules]="thirdPlayerRules$ | async"
      [categoryName]="categoryName$ | async" [players]="(players$ | async).items">
    </app-court-booking-save-player-add>
  </div>
  <div class="mt-3 mb-3" *ngIf="(showFourPlayers$ | async)">
    <div class="text-uppercase font-weight-bold" translate>CourtBookingSave.AddFourthPlayerLabel</div>
    <app-court-booking-save-player-add formControlName="fourthPlayer" [playerRules]="fourthPlayerRules$ | async"
      [categoryName]="categoryName$ | async" [players]="(players$ | async).items">
    </app-court-booking-save-player-add>
  </div>
</form>
